import React, { useState } from "react";
import api from "../config/api"; // Updated import path
import { Row, Col, Typography, Space } from "antd"; // Ant Design imports
import { Link, useNavigate } from "react-router-dom"; // Import Link
import { storage } from "src/common/localStorage";
import Logo from "src/components/Logo";
import {
  FormPassword,
  Form,
  FormText,
} from "src/components/Form";
import { Button } from "src/components";
import { login as loginSchema } from "src/shared/schema/user";

const { Title, Text } = Typography;

const Login = () => {
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (values) => {
    try {
      const response = await api.post("login", values);
      const { accessToken, refreshToken, user } = response.data;

      // Save auth data
      storage.saveAuthData(accessToken, refreshToken, user);

      // Redirect to dashboard
      navigate("/contracts");
    } catch (err) {
      setError("Login failed. Please check your credentials.");
    }
  };

  return (
    <Row justify="center" align="middle">
      <Col xs={24} sm={12} md={8}>
        <Form
          onSubmit={handleLogin}
          // schema={loginSchema}
          direction="vertical"
          size="middle"
          layout="vertical"
          style={{
            background: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            marginTop: "60px",
          }}
        >
          <div style={{ textAlign: "center", marginBottom: "20px" }}>

            <div
              className="logo"
              style={{ padding: "16px", alignItems: "center", display: "flex" }}
            >
              <img src="/jblogo.png" alt="JustBike Logo" />
            </div>
            {/* <Logo /> */}
            <Title level={2}>Sign in</Title>
          </div>
          <FormText
            name="name"
            placeholder="Email"
            autoComplete="email"
          />
          <FormPassword name="password" placeholder="Password" />
          {error && <Text type="danger">{error}</Text>}
          
          <Button type="primary" htmlType="submit" block>
            Sign in
          </Button>
          <Space style={{ marginTop: '10px', display: 'block', textAlign: 'center' }}>
            <Text>
              Don't have an account? <Link to="/register">Sign up</Link>
            </Text>
          </Space>
        </Form>
      </Col>
    </Row>
  );
};

export default Login;
